import React from 'react'
import { func, object } from 'prop-types'

import { Grid, Row, Col } from 'react-bootstrap'

import InputBlock from 'coact/InputBlock'
import Block from 'coact/Block'


function HeadEditor (props) {
  const { spliter, style, value } = props
  const getChildProps = spliter(props)

  return (
    <div className={style['form-head']}>
      <Grid>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('key')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('companyRef')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('stafferRef')} />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('supplierRef')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('orderDate')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('billDate')} />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('deleteOrder')} />
          </Col>
          <Col md={4}>
            <Block name="總金額">
              <span>{value.total}</span>
            </Block>
          </Col>
          <Col md={4}>
            <Block name="數量合計">
              <span>{value.summary}</span>
            </Block>
          </Col>
        </Row>
      </Grid>
    </div>
  )
}

HeadEditor.propTypes = {
  spliter: func.isRequired,
  value: object,
  style: object.isRequired,
}

export default HeadEditor



// WEBPACK FOOTER //
// ./src/components/PurchaseOrderEditor/HeadEditor/HeadEditor.jsx